<template>
    <v-card>
        <div class="card-title">{{ $t('InsightsTitle') }}</div>
        <v-card-text>

            <iframe width="100%" class="insights" src="https://cm-analytics.momah.gov.sa/s/b7f4d7dc5df244eb8b05f84f7d14b79f/app/dashboards#/view/5e4d4c50-8875-11ef-8e27-6f8b6d79b084?embed=true&_g=(filters%3A!()%2CrefreshInterval%3A(pause%3A!t%2Cvalue%3A0)%2Ctime%3A(from%3Anow-15m%2Cto%3Anow))"></iframe>
            <iframe width="100%" class="insights" src="https://cm-analytics.momah.gov.sa/s/1bfd0aa64d4f4b04a702e83b7f658f1e/app/dashboards#/view/8a3427a0-8a08-11ef-8e27-6f8b6d79b084?embed=true&_g=(filters%3A!()%2CrefreshInterval%3A(pause%3A!t%2Cvalue%3A0)%2Ctime%3A(from%3Anow-15m%2Cto%3Anow))"></iframe>
        </v-card-text>
    </v-card>
</template>

<script>

    export default {
        components: {
        },
        directives: {
        },
        filters: {
        },
        props: {
        },
        data() {
            return {
            }
        },
        computed: {
        },
        watch: {
        },
        beforeCreate() {
        },
        created() {
        },
        beforeMount() {
        },
        mounted() {
        },
        updated() {
        },
        activated() {
        },
        deactivated() {
        },
        beforeDestroy() {
        },
        destroyed() {
        },
        methods: {
        },
    }
</script>

<style scoped>
    .insights {
        height: 150vh;
        border: 0 !important
    }
</style>